<template>
  <font-awesome-icon
    v-if="text"
    v-b-tooltip.focus.hover="text"
    :icon="['far', 'question-circle']"
    class="align-baseline icon-color"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  text: {
    type: String,
    default: '',
  },
}

@Component
export default class HelpfulTooltip extends Vue.extend({ props }) {}

</script>

<style scoped>

.icon-color {
  color: rgb(200, 200, 200);
}

</style>
